import { render, staticRenderFns } from "./UserProfileEditPassword.vue?vue&type=template&id=a8486f74&scoped=true"
import script from "./UserProfileEditPassword.vue?vue&type=script&lang=js"
export * from "./UserProfileEditPassword.vue?vue&type=script&lang=js"
import style0 from "./UserProfileEditPassword.vue?vue&type=style&index=0&id=a8486f74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8486f74",
  null
  
)

export default component.exports